const ded = `
<h1>Artificial Intelligence (AI) Usage Policy on the DressDown Platform</h1>

<h2>Compliance with EU Legislation</h2>
<p>DressDown adheres to the legal standards of the European Union, including:</p>
<ul>
  <li>General Data Protection Regulation (GDPR): when processing personal data.</li>
  <li>Artificial Intelligence Act (AI Act): in the use and implementation of AI systems.</li>
  <li>Charter of Fundamental Rights of the European Union: especially Articles 7 (respect for private and family life) and 8 (protection of personal data).</li>
</ul>

<h2>Transparency and Labeling of AI-Generated Content</h2>
<p>All images generated using artificial intelligence technologies are mandatorily accompanied by a clear label:<br>
<strong>Generated by AI. Not a real photograph. Any resemblance is purely coincidental.</strong></p>
<p>This practice ensures transparency and user awareness, complying with principles of fairness and honesty as enshrined in EU law, particularly Regulation (EU) 2019/1150 on promoting fairness and transparency for business users of online platforms, as well as the Code of Practice on Disinformation recommended by the European Commission.</p>
<p>Special attention is paid to labeling content that may be perceived as journalistic, scientific, or politically significant, to avoid the spread of disinformation and to safeguard users’ right to accurate information, in accordance with Article 11 (freedom of expression) of the EU Charter of Fundamental Rights.</p>

<h2>Consent and Privacy Protection</h2>
<ul>
  <li>The use of real images of individuals without their explicit consent is prohibited, including:
    <ul>
      <li>Photos from personal accounts.</li>
      <li>Biometric data.</li>
      <li>Medical and intimate images.</li>
    </ul>
  </li>
  <li>We do not store or use sensitive personal data in generative systems.</li>
</ul>

<h2>Restrictions on Harmful Content</h2>
<p>DressDown's AI systems must not be used to generate or distribute:</p>
<ul>
  <li>Content containing discrimination, racism, sexism, or other forms of hate.</li>
  <li>Violent, pornographic, or defamatory imagery.</li>
  <li>Disinformation or deepfakes that mislead or damage reputations.</li>
</ul>

<h2>Ethical Restrictions and Moderation</h2>
<ul>
  <li>Requests that violate public norms or may cause social harm are automatically blocked.</li>
  <li>Moderation is in place: suspicious activities may be reviewed manually.</li>
  <li>Content violating the policy is removed, and violators are blocked.</li>
</ul>

<h2>Copyright Protection</h2>
<ul>
  <li>Image generation must not replicate recognizable styles of artists and photographers without their permission.</li>
  <li>It is prohibited to create works that may infringe on the intellectual property rights of third parties.</li>
</ul>

<h2>Technical Protection Measures</h2>
<p>The DressDown.me platform implements a set of technical and organizational measures to ensure the security of data processing associated with the use of artificial intelligence (AI) technologies. These measures are aimed at protecting users' personal data from unauthorized access, loss, alteration, or disclosure, as well as ensuring compliance with current legislation.</p>
<p><strong>Key measures include:</strong></p>
<ul>
  <li>Data encryption during transmission and storage using modern security protocols such as TLS/SSL, in accordance with the recommendations of the European Union Agency for Cybersecurity (ENISA).</li>
  <li>Restricting access to AI systems and personal data to only authorized employees and partners who are bound by confidentiality obligations in accordance with Article 32 of the GDPR (Security of Processing).</li>
  <li>Regular updates of software and hardware to eliminate vulnerabilities and prevent cyberattacks.</li>
  <li>Continuous monitoring, auditing, and testing of security systems to detect and respond to incidents in a timely manner, in compliance with ISO/IEC 27001 Information Security Management standards.</li>
  <li>Ensuring compliance with the General Data Protection Regulation (GDPR) (Regulation (EU) 2016/679), as well as other applicable EU regulations.</li>
</ul>
<p>Data processing involving AI is carried out in accordance with the principles of data minimization (Art. 5 GDPR) and purpose limitation, and data is not stored longer than necessary to achieve processing purposes.</p>

<h2>Your Rights</h2>
<p>In accordance with the GDPR, users have the right to:</p>
<ul>
  <li>Access their data.</li>
  <li>Withdraw consent to its processing.</li>
  <li>Request deletion or correction of data related to image generation.</li>
</ul>
<p>If you believe your content, likeness, or data has been used without consent, you may contact us at <a href="mailto:dressdown@dressdown.me">dressdown@dressdown.me</a>. We guarantee review and response within 30 calendar days.</p>
`;

export default ded
